import { Envelope } from "./Envelope";

export class SlotConfig {
    id: number;
    correctEnvelopeId: number;

    constructor(id: number, correctEnvelopeId: number) {
        this.id = id;
        this.correctEnvelopeId = correctEnvelopeId;
    }
}

export class Slot extends Phaser.GameObjects.Zone {
    id: number; // Corresponds to the order as well
    correctEnvelopeId: number;
    envelopeId: number;
    correct: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number, config: SlotConfig) {
        super(scene, x, y, width, height);

        this.id = config.id;
        this.correctEnvelopeId = config.correctEnvelopeId;
        this.envelopeId = -1;
        this.correct = false;


        this.setRectangleDropZone(width, height);

        scene.add.existing(this);

    }

    public static Slots: SlotConfig[] = [
        new SlotConfig(0, 1),
        new SlotConfig(1, 2),
        new SlotConfig(2, 3),
        new SlotConfig(3, 4),
        new SlotConfig(4, 5),
        new SlotConfig(5, 6),
        new SlotConfig(6, 7),
    ];
}





// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/objects/Slot.ts